import type { FiltroCargarEstudiantes } from '../store/slices/estudianteFotoSlice';
import http from './http';
import type { IStudentPhoto } from '../models/estudiante_foto_model';
import type { Area } from 'react-easy-crop';

export const getStudentPhotosService = async (
  tab: 'recibidos' | 'aprobados' | 'rechazados',
  filtersParams?: FiltroCargarEstudiantes,
) => {
  try {
    const filters = [];
    if (filtersParams?.codigoEstudiante) {
      filters.push(`codigoEstudiante=${filtersParams.codigoEstudiante}`);
    }
    if (filtersParams?.curso) {
      filters.push(`curso=${filtersParams.curso}`);
    }
    if (filtersParams?.idEstudiante) {
      filters.push(`idEstudiante=${filtersParams.idEstudiante}`);
    }
    if (filtersParams?.gestion) {
      filters.push(`gestion=${filtersParams.gestion}`);
    }
    if (filtersParams?.fechaDesde) {
      filters.push(`fechaDesde=${filtersParams.fechaDesde}`);
    }
    if (filtersParams?.fechaHasta) {
      filters.push(`fechaHasta=${filtersParams.fechaHasta}`);
    }

    if (filtersParams?._limit) {
      filters.push(`_limit=${filtersParams._limit}`);
    }
    if (filtersParams?._page) {
      filters.push(`_page=${filtersParams._page}`);
    }

    if (tab === 'recibidos') {
      filters.push(`estado=PENDIENTE`);
    } else if (tab === 'rechazados') {
      filters.push(`estado=OBSERVADO`);
    }
    else {
      filters.push(`estado=ACTIVO`);
    }

    return await http.get<{
      rows: IStudentPhoto[];
      count: number;
    }>(
      `/fotos-estudiantes/${filters.length ? '?' + filters.join('&') : ''}`,
    );
  } catch (error) {
    console.error('[get_reglamentos]  Error -> ', error);
    return {
      rows: [],
      count: 0,
    };
  }
};

export const rejectStudentPhotoService = async (
  idSolicitud: string,
  idStudent: string,
  motivo: string,
) => {
  try {
    return await http.put(`/fotos-estudiantes/${idSolicitud}/rechazar`, {
      motivo,
      idStudent,
    });
  } catch (error) {
    console.log('Error en rejectStudentPhotoService', error);
    return null;
  }
};

export const createStudentPhotoService = async (
  idStudent: string,
  image: File,
) => {
  try {
    const formData = new FormData();
    formData.append('idStudent', idStudent);
    if (image) {
      formData.append('file', image);
    }
    return await http.post(
      `/fotos-estudiantes/create`,
      formData,
      {
        'Content-Type': 'multipart/form-data',
      },
    );
  } catch (error) {
    console.log('Error en createStudentPhotoService', error);
    return null;
  }
};

export const approveStudentPhotoService = async (
  idSolicitud: string,
  idStudent: string,
  crop?: Area,
) => {
  try {
    const formData = new FormData();
    formData.append('idStudent', idStudent);
    if (crop) {
      // El recorte se genera en el backend a partir de la foto original ya
      // almacenada: generarlo en el cliente con <canvas> no es confiable en
      // Safari (puede producir un archivo vacío en silencio).
      formData.append('crop', JSON.stringify(crop));
    }
    return await http.put(
      `/fotos-estudiantes/${idSolicitud}/aprobar`,
      formData,
      {
        'Content-Type': 'multipart/form-data',
      },
    );
  } catch (error) {
    console.log('Error en approveStudentPhotoService', error);
    return null;
  }
};

export const downloadPhotoStudent = async (
  idSolicitud: string,
  fileName: string,
) => {
  try {
    const response = await http.download(
      `/fotos-estudiante/solicitud/${idSolicitud}/download`,
      fileName,
      // fileName.split('.').pop().toLowerCase() || 'JPG',
    );
    return response;
  } catch (error) {
    console.error('Error al descargar el archivo del reglamento :: ', error);
    return null;
  }
};

export const downloadPhotosStudentLote = async (
  tab: 'recibidos' | 'aprobados',
  filtersParams?: FiltroCargarEstudiantes,
) => {
  try {
    const filters = [];
    if (filtersParams?.codigoEstudiante) {
      filters.push(`codigoEstudiante=${filtersParams.codigoEstudiante}`);
    }
    if (filtersParams?.curso) {
      filters.push(`curso=${filtersParams.curso}`);
    }
    if (filtersParams?.idEstudiante) {
      filters.push(`idEstudiante=${filtersParams.idEstudiante}`);
    }
    if (filtersParams?.gestion) {
      filters.push(`gestion=${filtersParams.gestion}`);
    }
    if (filtersParams?.fechaDesde) {
      filters.push(`fechaDesde=${filtersParams.fechaDesde}`);
    }
    if (filtersParams?.fechaHasta) {
      filters.push(`fechaHasta=${filtersParams.fechaHasta}`);
    }

    if (tab === 'recibidos') {
      filters.push(`estado=PENDIENTE`);
    } else {
      filters.push(`estado=ACTIVO`);
    }

    return await http.download(
      `/fotos-estudiantes/lote${filters.length ? '?' + filters.join('&') : ''}`,
      'student-photos.zip', 'ZIP'
    );
  } catch (error) {
    console.error('[get_reglamentos]  Error -> ', error);
    return {
      rows: [],
      count: 0,
    };
  }
};
